import axios from 'axios';

const API_URL = `${window.location.origin}/api`;


const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401 &&
      !error.config.url.includes('/auth/check')) {
      localStorage.removeItem('user');
      // window.location.href = '/login';
    }

    if (error.response && error.response.status === 403 &&
      error.response.data.requiresShopSelection) {
      localStorage.removeItem('user');
      // window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);


export default api;